module.exports = __webpack_public_path__ + "img/1ST.0ab0097d.svg";